// Централизованная конфигурация фронтенда.
// Базовый URL API задаётся через переменную окружения REACT_APP_API_URL
// на этапе сборки (см. .env / .env.production). По умолчанию — локальный backend.

export const API_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");

// WebSocket-URL выводится из API_URL: http→ws, https→wss
export const WS_URL = API_URL.replace(/^http/, "ws");
